export default "__VITE_ASSET__BWPmAKFs__";